export function insertArray(array, asIndex, item) {
    const newArr = [...array];
    newArr.splice(asIndex, 0, item);
    return newArr;
}
